import { Options } from 'highcharts/highstock';

export const setXAxis = (options: Options, lastPredictionDate: number) => {
    options.xAxis = {
        type: 'datetime',
        plotBands: [
            {
                from: Number(new Date()),
                to: lastPredictionDate,
                color: 'rgba(220, 220, 220, 0.3)',
            },
        ],
        plotLines: [
            {
                color: '#a9a9a9',
                dashStyle: 'Dash',
                width: 3,
                value: Number(new Date()),
            },
        ],
    };
};
